import React, { Component } from 'react'
import { base_url } from '../constants';
import swal from 'sweetalert';

export class Allregister extends Component {
    state = {
        register: []
    }
    componentDidMount() {
        fetch(`${base_url}/user/fetchregister`)
        .then((response) => response.json())
        .then(productList => {
            this.setState({ register: productList });
        });
    }
    logout = () => {
        localStorage.removeItem("admintoken");
        localStorage.clear();
        this.setState({ redirect: true });
        swal({
            title: "Done!",
            text: "Logout Success",
            icon: "success",
            timer: 1000,
            button: false
          })
    
          window.location='/';
    
    }
    render() {
        return (
            <div class="main-content">
            <div className="panel-body">
            <div className="content-area">
                <div className="sub-bar">
                <div className="sub-title">
                    <h4>Dashboard:</h4>
                    <span>Welcome To web Admin Panel!</span>
                </div>
                <ul className="bread-crumb">
                 <li><button   class="btn btn-outline-primary" onClick={this.logout}>Logout</button></li> 
                    <li>Register</li>
                </ul>
                </div>
                <div className="gap no-gap">
                <div className="inner-bg">
                    <div className="element-title">
                    <div className="col-md-12">
                        <div class="row">
                            <div class="col-lg-6">
                            <h4>Register List</h4>
                            </div>
                        </div>
                    </div>
                 </div>
                    <table className="cart-table table table-responsive">
                    <thead>
                        <tr>
                        <th>Id</th>
                        <th>Role</th>
                        <th>Name</th>
                        <th>Email</th>
                        
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.register.map((g) => (
                        <tr>
                       <td>{g._id}</td>
                        <td>{g.role}</td>
                        <td>{g.name}</td>
                        <td>{g.email}</td>   
                        </tr>
))}
                    </tbody>
                    </table>
                </div>
                </div>
            </div>
            </div>
        
    </div>
        )
    }
}


export default Allregister
